import AffirmationTranslationsUpdateRequest from '../../../../../Spirit/Admin/Interfaces/Models/AfirmationSerivce/AffirmationTranslationsUpdateRequest';
import CropAndSaveImageRequest from '../../../../../Spirit/Common/FileManager/Models/CropAndSaveImageRequest';

export default class AffirmationUpdateRequest  {
	Id?: number = null;
	IsPaid: boolean = false;
	UseBackgroundMusic: boolean = false;
	AnimationId?: string = '';
	Translations: Array<AffirmationTranslationsUpdateRequest> = null;
	Cover: CropAndSaveImageRequest = null;
	Back: CropAndSaveImageRequest = null;
	Icon: CropAndSaveImageRequest = null;
	constructor(obj?: Partial<AffirmationUpdateRequest>) {
		if (obj) {
			Object.assign(this, obj);
		}
	}
}
